var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45618 23.2499C1.21868 23.2499 0.656178 22.3499 1.21868 21.2624L11.2312 1.5749C11.7937 0.487402 12.6937 0.487402 13.2562 1.5749L23.2687 21.2624C23.8312 22.3499 23.2687 23.2499 22.0312 23.2499H2.45618Z",
    fill: "#FFCE31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0072 8.8502L11.0572 15.7877C11.1697 16.4627 12.0322 16.4627 12.1447 15.7877L13.1572 8.8502C13.3447 6.1502 9.81973 6.1502 10.0072 8.8502Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5822 20.1754C12.4521 20.1754 13.1572 19.4702 13.1572 18.6004C13.1572 17.7305 12.4521 17.0254 11.5822 17.0254C10.7124 17.0254 10.0072 17.7305 10.0072 18.6004C10.0072 19.4702 10.7124 20.1754 11.5822 20.1754Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e5464a319d9d70a707fbf57a2aadb1e1.svg";
export { ForwardRef as ReactComponent };